export const INTERNET_SERVICE_STATUS_PILL = {
  active: 'Active',
  disconnected: 'Disconnected',
  suspended: 'Suspended',
  unknown: 'Unknown',
  warning: 'Warning',
  // to be implemented
  cancelled: 'Cancelled',
  cancellingSoon: 'Cancelling soon',
  inactive: 'Inactive',
  inProgress: 'In progress',
  move: 'Move requested'
};

export const URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES = ['ref', 'promo'];
